import { forwardRef, useCallback, useImperativeHandle } from "react";
import { message } from "antd";
import IcRecordFinishLoading from "@/assets/images/ic_record_finish_loading.png";
import IC_UPLOAD from '@/assets/simulInter/ic_upload.svg?react'
import DraftViewImg from '@/assets/simulInter/draft_view.png'
import { selectFile } from "@/utils/uploadHelper";
import "./index.less";

interface FileUploaderProps {
  onFileUpload: (file: File) => void;
  isUploading: boolean;
  visible: boolean;
}

export interface FileUploaderRef {
  handleUploadClick: () => void;
}

const FileUploader = forwardRef<FileUploaderRef, FileUploaderProps>((props, ref) => {
  const { onFileUpload, isUploading, visible } = props;

  const handleUploadClick = useCallback(() => {
    console.log("handleUploadClick");
    if (isUploading) {
      message.warning("正在上传中，请稍后再试");
      return;
    }

    // 使用统一的文件选择器
    selectFile({
      accept: ".docx",
      maxSize: 20 * 1024 * 1024, // 20MB
      allowedExtensions: ["docx"],
      allowedMimeTypes: ["application/vnd.openxmlformats-officedocument.wordprocessingml.document"],
      onSelect: onFileUpload,
      onError: (error) => {
        message.warning(error);
      }
    });
  }, [onFileUpload, isUploading]);

  useImperativeHandle(ref, () => ({
    handleUploadClick,
  }));

  return (
    visible && <div className="mt-23 flex flex-col items-center">
      <img src={DraftViewImg} className="w-32 h-32 mb-3" />
      <div
        onClick={handleUploadClick}
        className={`mt-3 min-w-30 h-9.5 px-3.5 bg-mx-primary rd-2.5 flex flex-items-center flex-justify-center ${isUploading ? "cursor-not-allowed" : "cursor-pointer"}`}
      >
        {isUploading ? (
          <img src={IcRecordFinishLoading} className="rotation size-4.5" />
        ) : (
          <>
            <IC_UPLOAD className="w-4.5 h-4.5 mr-1" />
            <div className="text-#fff">上传发言稿</div>
          </>
        )}
      </div>
    </div>
  );
});

export default FileUploader;
